import { render, staticRenderFns } from "./DoctorFee.vue?vue&type=template&id=47217d0b&scoped=true"
import script from "./DoctorFee.vue?vue&type=script&lang=js"
export * from "./DoctorFee.vue?vue&type=script&lang=js"
import style0 from "./DoctorFee.vue?vue&type=style&index=0&id=47217d0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47217d0b",
  null
  
)

export default component.exports